import { Certifications } from '../types';
import { escapeHtml, sanitizeUrl } from '../utils/security';
import { sectionHeader } from './common';

export function buildCertifications(certifications: Certifications) {
    const root = document.querySelector('[data-section="certifications"]');
    if (!root) return;

    const itemsHtml = certifications.items.map(item => {
        const url = item.credentialUrl ? sanitizeUrl(item.credentialUrl) : '#';
        const targetAttr = item.credentialUrl ? 'target="_blank" rel="noopener"' : '';
        const ariaLabel = item.credentialUrl ? `aria-label="${escapeHtml(item.name)} (åpnes i ny fane)"` : '';

        return `
        <a href="${url}" ${targetAttr} ${ariaLabel} class="flex gap-4 items-start bg-white border border-n100 rounded-lg p-[22px] shadow-sm text-graphite transition-all hover:shadow-md hover:border-n200 animate-fadeUp focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sunset-dark">
            <div class="w-[46px] h-[46px] flex-shrink-0 rounded-md bg-creme border border-n100 flex items-center justify-center text-sunset-dark">
                <i data-lucide="${escapeHtml(item.icon)}" stroke-width="1.5" class="w-[22px] h-[22px]"></i>
            </div>
            <div class="flex-grow">
                <h3 class="text-[15px] leading-[1.35] font-semibold text-graphite mb-1.5">${escapeHtml(item.name)}</h3>
                <div class="text-[13px] text-n400 mb-2.5">${escapeHtml(item.issuer)} · ${escapeHtml(item.year)}</div>
                ${item.credentialUrl ? '<span class="font-mono text-[11px] font-semibold tracking-[1px] uppercase text-sunset-dark inline-flex items-center gap-[5px]">Verifiser <i data-lucide="arrow-up-right" stroke-width="2" class="w-3 h-3"></i></span>' : ''}
            </div>
        </a>
    `;
    }).join('');

    root.innerHTML = `
        ${sectionHeader(certifications.kicker, certifications.heading)}
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            ${itemsHtml}
        </div>
    `;
}
